export const actionTypes = {
  SET_REDIRECT: 'SET_REDIRECT',
};
export const setRedirect = redirect => {
  return {
    type: actionTypes.SET_REDIRECT,
    data: redirect,
  };
};
